module.exports = "<hybse-admin-listusers [userType]=\"'Issuer'\">\n\n</hybse-admin-listusers>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/users/issuers/issuers.component.html
// module id = ../../../../../src/app/components/pages/users/issuers/issuers.component.html
// module chunks = main